import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "userAttributes",
  initialState: {} as SliceState<{ password: string }>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const passwordReducer = formSlice.reducer;
export default passwordReducer;
